import { combineReducers } from 'redux'
import { Reducer } from 'interfaces'
import { RecentTransactionsDataState } from 'interfaces/moneyflow'
import { GET_RECENT_TRANSACTIONS, CHANGE_TRANSACTION_CATEGORY, SET_TRANSACTION } from 'actions/moneyflowActions'
import { isRequestAction, isFailAction, isSuccessAction } from 'helpers/actionsHelpers'
import { DiscardTrigger, createMoneyflowTrendDiscardTriggers, needDiscardData } from 'helpers/discardTriggerHelpers'
import { createEmptyCollection, concatCollections, setItemInCollection, getItemFromCollection } from 'helpers/normalizeHelpers'
import { processChangeTransactionCategory } from 'helpers/moneyflowHelpers'

const INITIAL_STATE = {
  isLoading: false,
  errorCode: null,
  payload: null,
}

const triggers: DiscardTrigger[] = [
  ...createMoneyflowTrendDiscardTriggers(null),
]

const recent: Reducer<RecentTransactionsDataState['recent']> = (prevState = INITIAL_STATE, action) => {
  if (needDiscardData(triggers)(action)) {
    return INITIAL_STATE
  }

  switch (action.type) {
    case GET_RECENT_TRANSACTIONS: {
      if (isRequestAction(action)) {
        return {
          ...prevState,
          isLoading: true,
          errorCode: null,
        }
      }

      if (isFailAction(action)) {
        return {
          ...prevState,
          isLoading: false,
          errorCode: action.payload.errorCode,
        }
      }

      return {
        isLoading: false,
        errorCode: null,
        payload: action.payload.response.transactions.allKeys,
      }
    }
  }

  return prevState
}

const all: Reducer<RecentTransactionsDataState['all']> = (prevState = createEmptyCollection(), action) => {
  switch (action.type) {
    case GET_RECENT_TRANSACTIONS: {
      if (!isSuccessAction(action)) {
        return prevState
      }
      return concatCollections(prevState, action.payload.response.transactions)
    }

    case SET_TRANSACTION: {
      const { transaction } = action.payload

      if (!transaction) {
        return prevState
      }

      const transactionToUpdate = getItemFromCollection(prevState, transaction.uid)

      if (!!transactionToUpdate) {
        return setItemInCollection(prevState, transaction, 'uid')
      }

      return prevState
    }

    case CHANGE_TRANSACTION_CATEGORY: {
      const nextCollection = processChangeTransactionCategory({
        type: null,
        prevCollection: prevState,
        action,
      })

      return nextCollection
    }
  }
  return prevState
}

export const transactions = combineReducers<RecentTransactionsDataState>({
  recent,
  all,
})
